import { render, staticRenderFns } from "./download_invoice.vue?vue&type=template&id=06a1b1d6&scoped=true&"
import script from "./download_invoice.vue?vue&type=script&lang=js&"
export * from "./download_invoice.vue?vue&type=script&lang=js&"
import style0 from "./download_invoice.vue?vue&type=style&index=0&id=06a1b1d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1b1d6",
  null
  
)

export default component.exports